export interface Testimonial {
  quote: string;
  name: string;
  role: string;
  city: string;
  photo: string;
}

export const testimonialsBatchOne: Testimonial[] = [
  {
    quote:
      'I had $1,850 in unpaid tuition sitting on my books. I printed the payment ladder on a Sunday, sent the first letter Monday, and had $1,400 of it back in eleven days. I had not asked in four months because I never knew what to say.',
    name: 'Danielle Whitfield',
    role: 'Licensed home daycare',
    city: 'Greensboro, NC',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/ba465d10-f0f8-4a04-a3dc-fd6cc2a041b8.jpg',
  },
  {
    quote:
      'My licensor showed up unannounced in March. I handed her the binder and she was done in twenty minutes — no corrections for the first time in nine years. She asked me where I got the tab structure.',
    name: 'Karen Lindqvist',
    role: 'Family child care',
    city: 'Duluth, MN',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/b720fd8e-ad8e-4b4d-94e5-641ad168cc51.jpg',
  },
  {
    quote:
      'We went from four open spots to a waitlist of nine in about seven weeks. The tour script is the whole thing — I stopped talking about my philosophy and started walking parents through the agreement. Most leave a deposit before they walk out.',
    name: 'Yolanda Reyes',
    role: 'Center director',
    city: 'San Antonio, TX',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/17e5afc4-2480-426d-98ac-78c715da41b4.jpg',
  },
];

export const testimonialsBatchTwo: Testimonial[] = [
  {
    quote:
      'I had not raised my rate since 2021 because I was terrified of losing families. I sent the announcement letter exactly as written — twenty-five dollars more a week, eleven families, nobody left. That is $14,300 a year I was leaving on the table out of fear.',
    name: 'Mei-Ling Chen',
    role: 'Home daycare provider',
    city: 'Bellevue, WA',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/93d74150-688c-4f28-b227-015eb3fb6d28.jpg',
  },
  {
    quote:
      'I trained my first assistant off the 30-day track instead of having her shadow me and hope. She was running afternoons on her own by week three. Last month I took two days off and the program did not blink.',
    name: 'Rachel Sorenson',
    role: 'Group family child care',
    city: 'Sioux Falls, SD',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/0520e27b-6879-4f72-bfca-69324752906d.jpg',
  },
  {
    quote:
      'I used to do paperwork until ten at night. Now it is Friday afternoon, about an hour, and it is done. Twenty-seven dollars gave me back four evenings a week — I do not know what else there is to say about that.',
    name: 'Denise Alcorn',
    role: 'Center director',
    city: 'Columbus, OH',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/0cd41fdb-e929-47de-ac72-dfd2f3dda805.jpg',
  },
];

export const testimonialsBatchTwoTitle =
  'And once the paperwork stops running the program';
